/**
 * Initial Setup Service – real API only.
 */

import { normalizeServiceError } from '../utils/serviceError';
import { serviceLogger } from '../utils/serviceLogger';
import * as realImpl from './real/initialSetupService.real';

export const initialSetup = async (payload) => {
  try {
    return await realImpl.initialSetup(payload);
  } catch (error) {
    serviceLogger.error('[initialSetup] Error:', error);
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw normalizeServiceError(error);
  }
};
